/**
 * Wave 2 additions to the games API client. Match + Crossword endpoints
 * mirror the existing patterns (cookie auth, single thin axios call).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const cfg = { withCredentials: true };

export const fetchMatchDaily = () =>
  axios.get(`${BACKEND_URL}/api/games/match/daily`, cfg).then((r) => r.data);

export const submitMatch = ({ flips, time_ms, completed = true }) =>
  axios
    .post(`${BACKEND_URL}/api/games/match/submit`, { flips, time_ms, completed }, cfg)
    .then((r) => r.data);

export const fetchCrosswordDaily = (language = 'en') =>
  axios
    .get(`${BACKEND_URL}/api/games/crossword/daily`, { ...cfg, params: { language } })
    .then((r) => r.data);

export const submitCrossword = (id, cells) =>
  axios
    .post(`${BACKEND_URL}/api/games/crossword/submit`, { id, cells }, cfg)
    .then((r) => r.data);
